<ul
  class="fixed top-0 left-0 bottom-0 right-0 z-50 flex flex-col justify-center items-center"
  [style.backgroundColor]="primaryBackground()"
>
  @for (item of menuItems(); track item.name) {
  <li class="w-1/2 px-4 py-3">
    <a
      #rla="routerLinkActive"
      [routerLink]="item.url | translate"
      [routerLinkActiveOptions]="{ exact: item.exact }"
      [fragment]="item.fragment"
      routerLinkActive="font-medium"
      (click)="menuItemClick.emit()"
      class="cursor-pointer"
      [ngStyle]="{
        color: navbarService.isLinkActiveWithFragment(item) ? primary() : '',
        fontWeight: navbarService.isLinkActiveWithFragment(item) ? '500' : ''
      }"
    >
      {{ item.name | translate }}
    </a>
  </li>
  }

  <neopos-icon-button
    name="close"
    (click)="menuItemClick.emit()"
    className="text-2xl"
    class="absolute top-4 right-4"
    [ariaLabel]="'Schowaj menu' | translate"
  />
</ul>
